import React, { forwardRef, useContext, useImperativeHandle, useRef } from "react";
import FormCreator from "../../../../components/forms/FormCreator";
import { useState } from "react";
import { AdditionalAddOnsSectionData, AdditionalGuestSectionData, PricingData } from "../../data/Pricing.Data";
import AdditionalAddOns from "./component/AdditionalAddOns";
import PricingDetails from "./component/PricingDetails";
import Buttons from "../../../../components/ui/button/Buttons";
import BasicDetailContext from "../../utils/BasicDetailContext";

const Pricing = forwardRef((props, ref) => {
  const pricingRef = useRef();
  const additionalGuestRef = useRef();
  const additionalAddOnRef = useRef();
  const [showAdditionalFees, setShowAdditionalFees] = useState(false);
  const { pricingPackageDetails, setPricingPackageDetails, alowPricingEdit, setAlowPricingEdit } = useContext(BasicDetailContext);

  // Expose method `getFormData` to parent components to retrieve form data from `FormCreator`
  useImperativeHandle(ref, () => ({
    pricingRef: {
      getFormData: () => {
        const pricingRefData = pricingRef.current.getFormData();
        if (pricingRefData) {
          return pricingRefData;
        }
        return null;
      },
    },
    additionalGuestRefData: {
      getFormData: () => {
        const additionalGuestRefData = additionalGuestRef.current.getFormData();
        if (additionalGuestRefData) {
          return additionalGuestRefData;
        }
        return null;
      },
    },
    additionalAddOnRef: {
      getFormData: () => {
        const additionalAddOnRefData = additionalAddOnRef.current.getFormData();
        if (additionalAddOnRefData) {
          return additionalAddOnRefData;
        }
        return null;
      },
    },
  }))

  const hideShowAdditionalFields = (value) => {
    setShowAdditionalFees(value);
  }

  const handleEnablePricingDetails = () => {
    setAlowPricingEdit(true);
  }

  const handleDisablePricingDetails = () => {
    setPricingPackageDetails(prev =>
      prev.map((packageDetail) => ({
        ...packageDetail,
        eventPrice: '0',
        earlyBird: '0',
        superEarlyBird: '0',
      })))
    setAlowPricingEdit(false)
  }

  const handleColumnChange = (field, data) => {
    debugger
    if (field === "isAdditionalAddOns")
      if (data.isAdditionalAddOns === "There is additional fee")
        hideShowAdditionalFields(true);
      else
        hideShowAdditionalFields(false);

    if (field === "isAttandance")
      if (data.isAttandance === "Attendance is free")
        handleDisablePricingDetails();
      else if (data.isAttandance === "There is a cost to attend")
        handleEnablePricingDetails();
  }

  return (
    <div>
      <FormCreator
        config={PricingData}
        ref={pricingRef}
        key={false}
        onColumnChange={handleColumnChange}
      //   onFieldBlure={handleFieldBlureChange}
      />
      <PricingDetails />
      <FormCreator
        config={AdditionalGuestSectionData}
        ref={additionalGuestRef}
        key={false}
      //   onColumnChange={handleColumnChange}
      //   onFieldBlure={handleFieldBlureChange}
      />
      <FormCreator
        config={AdditionalAddOnsSectionData}
        ref={additionalAddOnRef}
        key={false}
        onColumnChange={handleColumnChange}
      //   onFieldBlure={handleFieldBlureChange}
      />
      {showAdditionalFees && <AdditionalAddOns />}
      {/* <Buttons
        onClick={getDtata}
        buttonTypeClassName="btn theme-btn my-2"
        buttonText={"getDtata"}
      /> */}
    </div>
  );
});

export default Pricing;
